import { combineReducers } from 'redux-immutable';

import view from './View/reducer';

export default combineReducers({
  view,
});
